import { getItem } from '../../helpers/storage.helper';

export class AuthorizationToken {
  public token: string;

  constructor() {
    this.token = getItem('token');
  }
}
